// src/components/Layout.js
import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./header";
import Footer from "./footer";

const Layout = () => {
  return (
    <div>
      <Header />
      <main className="container mt-4 site-main">
        <Outlet /> {/* Сюди будуть вставлятися всі сторінки */}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
